import React, { useEffect, useState } from 'react';
import { faBusSimple, faMessage, faPhone, faRoad } from '@fortawesome/free-solid-svg-icons';
import DashboardCard from '../components/DashboardCard';
import BannerCard from '../components/DashboardBanner';
import bus from './../assets/travel.png';
import Footer from '../components/Footer';
import AppBar from '../components/AppBar';

const Dashboard = () => {
  const [userData, setUserData] = useState({});

  useEffect(() => {
    const user = window.localStorage.getItem("user");
    // console.log("User : ", user);
    if (user) {
      setUserData(JSON.parse(user))
    } else {
      setUserData({});
    }
  }, []);

  return (
    <div className="bg-gray-100 flex flex-col items-center h-screen overflow-hidden">
      <AppBar/>
  
      <div className="p-4">
        <div className="grid grid-cols-2 gap-4 mb-4 sm:gap-6 sm:mb-6  w-full">
          <div className="col-span-2">
            <BannerCard
              name={`${userData && userData?.fullname}`}
              appDetails="Welcome to the app. "
              busImageUrl={bus}
            />
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-4">
          <DashboardCard path="/allRoutes" heading="Routes" icon={faRoad} description="See list of routes and track buses"/>
          <DashboardCard path="/reservations" heading="Seat Bookings" icon={faBusSimple} description="Reserve seats and track buses for PND service" />
          <DashboardCard path="/allFeedbacks" heading="Feedback" icon={faMessage} description="Leave your feedback to improve our service"/>
          <DashboardCard path="/contactUs" heading="Contact Us" icon={faPhone} description="Reach out through Whatsapp or phone call"/>
        </div>

        <Footer/>
      </div>
    </div>
  );
};

export default Dashboard;
